const asyncLocalStorage = {
  setItem: function (key: string, value: string) {
    return Promise.resolve().then(function () {
      localStorage.setItem(key, value);
    });
  },
  getItem: function (key: string) {
    return Promise.resolve().then(function () {
      return localStorage.getItem(key);
    });
  },
  removeItem: function (key: string) {
    return Promise.resolve().then(function () {
      return localStorage.removeItem(key);
    });
  },
};

export default asyncLocalStorage;
